import { render, staticRenderFns } from "./RightFooterComponent.vue?vue&type=template&id=2aed64df&scoped=true"
import script from "./RightFooterComponent.vue?vue&type=script&lang=js"
export * from "./RightFooterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed64df",
  null
  
)

export default component.exports